/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_DisclaimerInputs */

const en_admin_ai_chat_disclaimer = /** @type {(inputs: Admin_Ai_Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers can contain mistakes. Check important numbers`)
};

const de_admin_ai_chat_disclaimer = /** @type {(inputs: Admin_Ai_Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten können Fehler enthalten. Wichtige Zahlen bitte prüfen`)
};

const es_admin_ai_chat_disclaimer = /** @type {(inputs: Admin_Ai_Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las respuestas pueden contener errores. Revisa las cifras importantes`)
};

const fr_admin_ai_chat_disclaimer = /** @type {(inputs: Admin_Ai_Chat_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les réponses peuvent contenir des erreurs. Vérifiez les chiffres importants`)
};

/** @type {(inputs: Admin_Ai_Chat_DisclaimerInputs) => LocalizedString} */
const nl_admin_ai_chat_disclaimer = en_admin_ai_chat_disclaimer;

/** @type {(inputs: Admin_Ai_Chat_DisclaimerInputs) => LocalizedString} */
const it_admin_ai_chat_disclaimer = en_admin_ai_chat_disclaimer;

/** @type {(inputs: Admin_Ai_Chat_DisclaimerInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_disclaimer = en_admin_ai_chat_disclaimer;

/** @type {(inputs: Admin_Ai_Chat_DisclaimerInputs) => LocalizedString} */
const pl_admin_ai_chat_disclaimer = en_admin_ai_chat_disclaimer;

/** @type {(inputs: Admin_Ai_Chat_DisclaimerInputs) => LocalizedString} */
const hu_admin_ai_chat_disclaimer = en_admin_ai_chat_disclaimer;

/** @type {(inputs: Admin_Ai_Chat_DisclaimerInputs) => LocalizedString} */
const ro_admin_ai_chat_disclaimer = en_admin_ai_chat_disclaimer;

/**
* | output |
* | --- |
* | "Answers can contain mistakes. Check important numbers" |
*
* @param {Admin_Ai_Chat_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_disclaimer = /** @type {((inputs?: Admin_Ai_Chat_DisclaimerInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_DisclaimerInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_disclaimer(inputs)
	if (locale === "de") return de_admin_ai_chat_disclaimer(inputs)
	if (locale === "es") return es_admin_ai_chat_disclaimer(inputs)
	if (locale === "fr") return fr_admin_ai_chat_disclaimer(inputs)
	if (locale === "nl") return nl_admin_ai_chat_disclaimer(inputs)
	if (locale === "it") return it_admin_ai_chat_disclaimer(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_disclaimer(inputs)
	if (locale === "pl") return pl_admin_ai_chat_disclaimer(inputs)
	if (locale === "hu") return hu_admin_ai_chat_disclaimer(inputs)
	return ro_admin_ai_chat_disclaimer(inputs)
});
export { admin_ai_chat_disclaimer as "admin.ai_chat.disclaimer" }